import * as app from './scripts/Core/App';
import * as DFPConfigProvider from './scripts/Modules/DFP/DFPConfigProvider';
import DFP from './scripts/Modules/DFP/DFP';
import MobileVersion from './scripts/Modules/MobileVersion';
app.start().then(() => {
    const mobileVersion = new MobileVersion();
    //if (!mobileVersion.isMobile()) {
        _initializeDFP();
    //}
});


function _initializeDFP() {
    const moduleConfig = DFPConfigProvider.GetConfig();
    const $module = new DFP(moduleConfig);

    $module.Load();
}


// WEBPACK FOOTER //
// ./Statics/dfp.js